import React from 'react'
import Downloads from 'components/Downloads'

export default function DownloadsScreen () {
  return (
    <Downloads />
  )
}
